/* eslint react/no-danger: "off" */
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { bindActionCreators } from 'redux'
import { getPageContent } from './getPageContent'
import { ContentRenderer } from './renderer'
import { scrollToElement } from '../../actions'

const mapStateToProps = (state, props) => ({ page: getPageContent(state.common.wordPressContent, props.contentKey) })

const mapDispatchToProps = (dispatch) => bindActionCreators(
  { scrollToElementDispatch: scrollToElement },
  dispatch
)

ContentRenderer.propTypes = {
  page: PropTypes.object.isRequired,
  contentKey: PropTypes.string.isRequired
}

const OffSiteContentComponent = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ContentRenderer)

export default OffSiteContentComponent
